import React, { type FunctionComponent, useMemo, useCallback } from 'react'
import { SelectField } from '@retailer-platform/shared-components/src/tds'
import { type ApprovalRequestState } from '../../api'
import { useDomainMessages } from '../../utils/domain/intl'

export type SelectRequestStatusProps = {
  value?: ApprovalRequestState
  onChange?: (str?: ApprovalRequestState) => void
}

export const SelectRequestStatus: FunctionComponent<
  React.PropsWithChildren<SelectRequestStatusProps>
> = ({ value, onChange, ...rest }) => {
  const i18n = useDomainMessages({
    allStatuses: 'approvalManagementLibrary.searchList.allStatuses',
    PENDING: 'approvalManagementLibrary.approvalRequestState.PENDING',
    APPROVED: 'approvalManagementLibrary.approvalRequestState.APPROVED',
    CANCELLED: 'approvalManagementLibrary.approvalRequestState.CANCELLED',
    PUBLISHED: 'approvalManagementLibrary.approvalRequestState.PUBLISHED',
    PUBLISHING: 'approvalManagementLibrary.approvalRequestState.PUBLISHING',
  })

  const options = useMemo(
    () => [
      { label: i18n.PENDING, value: 'PENDING' },
      { label: i18n.APPROVED, value: 'APPROVED' },
      { label: i18n.CANCELLED, value: 'CANCELLED' },
      { label: i18n.PUBLISHED, value: 'PUBLISHED' },
      { label: i18n.PUBLISHING, value: 'PUBLISHING' },
    ],
    [i18n]
  )

  const onChangeLocal = useCallback(
    (val: string | null) => {
      onChange?.(val as ApprovalRequestState)
    },
    [onChange]
  )

  return (
    <SelectField
      maxWidthPx={280}
      data-testid="select-request-status"
      options={options}
      value={value}
      onChange={onChangeLocal}
      placeholder={i18n.allStatuses}
      clearable
      searchable
      {...rest}
    />
  )
}
